import angular from 'angular';
import { getCreditNoteReasons } from '@/shared/services/CreditNoteReasonService';

angular.module('cloudX').directive('cxCreditNoteReasonSelect', [
  function() {
    return {
      restrict: 'E',
      template: `<a href="#"
                    editable-select="reasonId"
                    onshow="loadReasons()"
                    onbeforesave="beforeSave($data)"
                    e-ng-options="item.id as item.name for item in reasons | isActive:reasonId"
                    e-placeholder="{{'None'|translate}}"
                    edit-disabled="disabled">
                  <span ng-if="reason" ng-bind="reason.name"></span>
                  <i class="glyphicon glyphicon-pencil" ng-if="!reason"></i>
                </a>`,
      scope: {
        reason: '=data',
        save: '&',
        disabled: '=?',
      },
      controller: [
        '$scope',
        '$q',
        function($scope, $q) {
          $scope.reasons = [];

          $scope.$watch('reason', function(reason) {
            $scope.reasonId = reason ? reason.id : null;
          });

          // Loaded on show so the list is never stale. The isActive filter hides disabled
          // reasons, except the one that is currently set on the invoice.
          $scope.loadReasons = function() {
            return $q.when(getCreditNoteReasons()).then(function(reasons) {
              $scope.reasons = reasons.map(function(reason) {
                return angular.extend({}, reason, { isActive: !reason.disabled });
              });
            });
          };

          $scope.beforeSave = function(reasonId) {
            const selected = $scope.reasons.find(function(item) {
              return item.id === reasonId;
            });
            const newValue = selected ? { id: selected.id, name: selected.name } : null;

            return $q.when($scope.save({ newValue })).then(function(result) {
              // A string result means the save failed (xeditable keeps the form open and
              // shows it). On success the update response does not always carry the reason
              // back, so keep the displayed value in sync ourselves.
              if (!angular.isString(result)) $scope.reason = newValue;
              return result;
            });
          };
        },
      ],
    };
  },
]);
